import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReportTitlesQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReportTitlesQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReportTitlesQueryStore",
			variables: false,
		})
	}
}

export async function load_ReportTitlesQuery(params) {
  await initClient()

	const store = new ReportTitlesQueryStore()

	await store.fetch(params)

	return {
		ReportTitlesQuery: store,
	}
}
